module.exports = __webpack_public_path__ + "img/phone.71f5bdba.svg";